// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tt-2";
export var chatLink = "_tt-0";
export var chatText = "_tt-1";